import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CursorGlow from "@/components/CursorGlow";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Work from "@/pages/Work";
import CaseStudy from "@/pages/CaseStudy";
import IndustryPage from "@/pages/IndustryPage";
import Pricing from "@/pages/Pricing";
import FAQ from "@/pages/FAQ";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import { ContentProvider } from "@/context/ContentContext";
import { AuthProvider } from "@/context/AuthContext";
import RouteAnalytics from "@/components/RouteAnalytics";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) {
            window.__lenis.scrollTo(0, { immediate: true });
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname]);
    return null;
}

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const loop = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <BrowserRouter>
            <ContentProvider>
                <AuthProvider>
                    <AppShell />
                </AuthProvider>
            </ContentProvider>
        </BrowserRouter>
    );
}

function AppShell() {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");

    return (
        <div className="min-h-screen bg-void text-white">
            <div className="grain-overlay" aria-hidden="true" />
            <CursorGlow />
            <RouteAnalytics />
            <ScrollToTop />
            {!isAdmin && <Navbar />}
            <main>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/work" element={<Work />} />
                    <Route path="/work/:slug" element={<CaseStudy />} />
                    <Route path="/industries/:slug" element={<IndustryPage />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/payment-success" element={<PaymentSuccess />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </main>
            {!isAdmin && <Footer />}
            <Toaster theme="dark" position="bottom-right" />
        </div>
    );
}
